import { setupApplicationAction } from 'actions/applicationActions'
import { nextCameraAction } from 'actions/cameraActions'
import { screenshotCapturedAction } from 'actions/exportActions'

const getDeviceIds = entities => {
  const { doorControllers, networkClosets, wiredDevices } = entities
  const doorControllerIds = Object.values(doorControllers.byId).filter(c => !c.isExpansion).map(c => ({ id: c.id, type: 'doorController' }))

  return doorControllerIds.concat(wiredDevices.allIds.map(id => ({ id, type: 'wiredDevice' })), networkClosets.allIds.map(id => ({ id, type: 'networkCloset' })))
}

export default function({ dispatch }) {
  return ({
    setupApplication: project => dispatch(setupApplicationAction(project)),
    setupStepThrough: project => {
      const data = project.permalink || project

      return dispatch(setupApplicationAction({
        ...data,
        cameraIds: data.cameras.filter(c => !c.isMultiImager).map(c => c.id),
        deviceIds: getDeviceIds(data.entities),
        exportType: data.exportType || 'Collection'
      }, true))
    },
    nextCamera: _ => dispatch(nextCameraAction()),
    takeScreenshot: opts => window.callChrome ? window.callChrome({ type: 'TAKE_SCREENSHOT', ...opts }) : dispatch(screenshotCapturedAction()) && console.log('callChrome -TAKE_SCREENSHOT', ...Object.entries(opts)),
    exit: error => window.callChrome ? window.callChrome({ type: 'EXIT', error }) : console.log('callChrome - EXIT'),
    screenshotCaptured: _ => dispatch(screenshotCapturedAction())
  })
}



// WEBPACK FOOTER //
// ./src/helpers/createHandlers.js